import { render, staticRenderFns } from "./NewCompany.vue?vue&type=template&id=f7cf8a8e&scoped=true&"
import script from "./NewCompany.vue?vue&type=script&lang=js&"
export * from "./NewCompany.vue?vue&type=script&lang=js&"
import style0 from "./NewCompany.vue?vue&type=style&index=0&id=f7cf8a8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7cf8a8e",
  null
  
)

export default component.exports